import { Pba } from '../pba';

export class TestedPartyModalPayload {
  pba: Pba;
  isEdit: boolean;
}
